"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importStar(require("../../styled"));
var tokens_1 = require("../../tokens");
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var container_styles_1 = __importDefault(require("../../_helpers/container-styles"));
var uniqueId_1 = __importDefault(require("../../_helpers/uniqueId"));
var Tabs = (function (_super) {
    __extends(Tabs, _super);
    function Tabs(props) {
        var _this = _super.call(this, props) || this;
        _this.tabs = _this.getTabsFromProps(props);
        _this.state = {
            selectedIndex: _this.getSelectedTabFromChildProps(_this.tabs)
        };
        return _this;
    }
    Tabs.prototype.getTabsFromProps = function (props) {
        return React.Children.toArray(props.children);
    };
    Tabs.prototype.componentWillReceiveProps = function (newProps) {
        this.tabs = this.getTabsFromProps(newProps);
        this.setState({
            selectedIndex: this.getSelectedTabFromChildProps(this.tabs)
        });
    };
    Tabs.prototype.getSelectedTabFromChildProps = function (tabs) {
        var selected = this.props.selected;
        if (selected) {
            return selected;
        }
        for (var index = 0; index < tabs.length; index++) {
            if (tabs[index].props.selected) {
                return index;
            }
        }
        return 0;
    };
    Tabs.prototype.changeTab = function (nextIndex) {
        var currentIndex = this.props.selected;
        if (currentIndex !== nextIndex) {
            this.props.onSelect(nextIndex);
        }
    };
    Tabs.prototype.handleTabLinkKeypress = function (e, index, tabsId, tabsLength) {
        if (e.key === 'Enter' || e.key === ' ') {
            this.changeTab(index);
            return;
        }
        if (!(e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
            return;
        }
        var firstTabIndex = 0;
        var lastTabIndex = tabsLength - 1;
        var nextPosition = e.key === 'ArrowLeft' ? index - 1 : index + 1;
        if (nextPosition > lastTabIndex) {
            nextPosition = firstTabIndex;
        }
        if (nextPosition < firstTabIndex) {
            nextPosition = lastTabIndex;
        }
        this.changeFocusedTab(tabsId, nextPosition);
    };
    Tabs.prototype.changeFocusedTab = function (tabsId, index) {
        var tab = document.querySelector("#" + tabsId + "-" + index);
        tab.focus();
    };
    Tabs.prototype.render = function () {
        var _this = this;
        var uniqueTabPrefix = "tabs" + this.props.id;
        var _a = this.props, selectedIndex = _a.selected, onSelect = _a.onSelect, restOfTheProps = __rest(_a, ["selected", "onSelect"]);
        return (React.createElement(Tabs.Element, __assign({}, automation_attribute_1.default('tabs'), restOfTheProps),
            React.createElement(Tabs.TabList, __assign({ role: "tablist" }, automation_attribute_1.default('tabs.list')), this.tabs.map(function (tab, index) {
                var id = uniqueTabPrefix + "-" + index;
                var tabIsSelected = selectedIndex === index;
                return (React.createElement(Tabs.TabListItem, __assign({ role: "presentation", key: id }, automation_attribute_1.default('tabs.list-item')),
                    React.createElement(Tabs.TabLink, __assign({ type: "button", role: "tab", id: id, tabIndex: tabIsSelected ? '0' : '-1', "aria-selected": tabIsSelected, "aria-controls": id + '-tab', onClick: function () { return _this.changeTab(index); }, onKeyDown: function (e) {
                            return _this.handleTabLinkKeypress(e, index, uniqueTabPrefix, _this.tabs.length);
                        } }, automation_attribute_1.default('tabs.link')), tab.props.label)));
            })),
            this.tabs[selectedIndex] &&
                React.cloneElement(this.tabs[selectedIndex], __assign({ role: 'tabpanel', id: uniqueTabPrefix + "-" + selectedIndex + "-tab", 'aria-labelledby': uniqueTabPrefix + "-" + selectedIndex }, automation_attribute_1.default('tabs.item')))));
    };
    Tabs.Element = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), container_styles_1.default);
    Tabs.TabList = styled_1.default.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    border-bottom: 1px solid ", ";\n  "], ["\n    display: flex;\n    border-bottom: 1px solid ", ";\n  "])), tokens_1.colors.base.grayLight);
    Tabs.TabListItem = styled_1.default.li(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    &:not(:last-child) {\n      margin-right: ", ";\n    }\n  "], ["\n    &:not(:last-child) {\n      margin-right: ", ";\n    }\n  "])), tokens_1.spacing.large);
    Tabs.TabLink = styled_1.default.button(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    /* Resets button browser styles */\n    background-color: transparent;\n    border: none;\n    padding: ", " 0;\n    color: ", ";\n    cursor: pointer;\n    border-bottom: 1px solid transparent;\n    margin-bottom: -1px;\n    line-height: 1.3;\n\n    &:hover {\n      color: ", ";\n    }\n    &:focus {\n      outline: none;\n      border-bottom-color: ", ";\n    }\n    &:active {\n      border-bottom-color: ", ";\n    }\n    ", ";\n  "], ["\n    /* Resets button browser styles */\n    background-color: transparent;\n    border: none;\n    padding: ", " 0;\n    color: ", ";\n    cursor: pointer;\n    border-bottom: 1px solid transparent;\n    margin-bottom: -1px;\n    line-height: 1.3;\n\n    &:hover {\n      color: ", ";\n    }\n    &:focus {\n      outline: none;\n      border-bottom-color: ", ";\n    }\n    &:active {\n      border-bottom-color: ", ";\n    }\n    ",
        ";\n  "])), tokens_1.spacing.small, tokens_1.colors.link.default, function (props) { return (!props['aria-selected'] ? tokens_1.colors.link.defaultHover : tokens_1.colors.text.default); }, tokens_1.colors.link.default, tokens_1.colors.base.text, function (props) {
        return props['aria-selected'] && styled_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        border-bottom: 1px solid ", ";\n        cursor: default;\n        color: ", ";\n        &:focus {\n          border-bottom: 1px solid ", ";\n        }\n      "], ["\n        border-bottom: 1px solid ", ";\n        cursor: default;\n        color: ", ";\n        &:focus {\n          border-bottom: 1px solid ", ";\n        }\n      "])), tokens_1.colors.base.text, tokens_1.colors.text.default, tokens_1.colors.base.text);
    });
    Tabs.TabContent = styled_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), tokens_1.spacing.large);
    Tabs.Tab = Tabs.TabContent;
    Tabs.defaultProps = {
        children: [],
        id: uniqueId_1.default()
    };
    return Tabs;
}(React.Component));
exports.default = Tabs;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=tabs.js.map